module.exports = __webpack_public_path__ + "ca93c67ac9819af8e75a2f7cd023b60d.jpeg";


//////////////////
// WEBPACK FOOTER
// ./public/bg28.jpeg
// module id = 37
// module chunks = 0